import React from "react";
import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  useColorModeValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { useSearch } from "../../../contexts/SearchContext"; // Asegúrate de importar el contexto

export function SearchBar(props) {
  const { variant, background, placeholder, borderRadius, ...rest } = props;

  const searchIconColor = useColorModeValue("gray.700", "white");
  const inputBg = useColorModeValue("secondaryGray.300", "navy.900");
  const inputText = useColorModeValue("gray.700", "gray.100");

  const { draftSearchQuery, updateDraftSearchQuery, applyFilters } = useSearch();

  const handleInputChange = (e) => {
    updateDraftSearchQuery(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      applyFilters();
    }
  };

  return (
    <InputGroup w={{ base: "100%", md: "200px" }} {...rest}>
      <InputLeftElement>
        <IconButton
          bg="inherit"
          borderRadius="inherit"
          _hover="none"
          _active={{ bg: "inherit", transform: "none", borderColor: "transparent" }}
          _focus={{ boxShadow: "none" }}
          icon={<SearchIcon color={searchIconColor} w="15px" h="15px" />}
        />
      </InputLeftElement>
      <Input
        variant="search"
        fontSize="sm"
        bg={background || inputBg}
        color={inputText}
        fontWeight="500"
        _placeholder={{ color: "gray.400", fontSize: "14px" }}
        borderRadius={borderRadius || "md"}
        borderWidth="1px"
        borderColor="gray.200"
        placeholder={placeholder || 'Buscar…'}
        value={draftSearchQuery}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
    </InputGroup>
  );
}